import React from 'react';

const WaterReminder = () => {
  const message = "Water is very important for our body, so remember to drink still water in the day and after treatment!";
  
  return (
    <section className="py-8 bg-blue-100 overflow-hidden">
      <div className="relative">
        {/* Simple marquee container */}
        <div className="flex animate-marquee">
          {/* Multiple instances for continuous effect */}
          {[...Array(20)].map((_, index) => (
            <div key={index} className="flex-shrink-0 whitespace-nowrap px-8">
              <div className="flex items-center space-x-4">
                <div className="text-blue-600 text-2xl">💧</div>
                <p className="text-blue-800 text-lg font-medium" style={{ fontFamily: "Playfair Display, serif" }}>
                  {message}
                </p>
                <div className="text-blue-600 text-2xl">💧</div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Gradient overlays for smooth fade effect */}
        <div className="absolute top-0 left-0 w-20 h-full bg-gradient-to-r from-blue-100 to-transparent z-10"></div>
        <div className="absolute top-0 right-0 w-20 h-full bg-gradient-to-l from-blue-100 to-transparent z-10"></div>
      </div>
    </section>
  );
};

export default WaterReminder;
